import React from 'react';
import { useAppDispatch } from '../../hooks/store-hooks';
import useView from '../../features/home/hooks/use-view';
import { patchFocusedWorkspaceView } from '../../state/store';
import { layerDescriptors } from './layers';
import { Command } from './types';

export function useLayerCommands(): Command[] {
    const dispatch = useAppDispatch();
    const { view } = useView();

    return React.useMemo<Command[]>(
        () =>
            layerDescriptors.map((layer) => {
                const on = layer.get(view);
                return {
                    id: `layer-${layer.id}`,
                    title: `${layer.label} layer`,
                    keywords: ['layer', 'toggle', 'show', 'hide', layer.label],
                    group: 'Layers',
                    checked: on,
                    run: () => dispatch(patchFocusedWorkspaceView((v) => layer.toggle(v)))
                };
            }),
        [view, dispatch]
    );
}

